module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('br'), _vm._v(" "), (_vm.role === 'ROLE_USER' && _vm.isMobile) ? _c('div', {
    staticClass: "my-trainings-div"
  }, [_c('div', {
    staticClass: "my-trainings-div half"
  }, [_c('div', {
    staticClass: "my-trainings-button",
    on: {
      "click": function($event) {
        return _vm.showMyTrainingsFun()
      }
    }
  }, [_c('img', {
    staticClass: "icon-sm",
    attrs: {
      "src": require("../../assets/img/icons/my_trainings.svg")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "my-trainings-text"
  }, [_vm._v(" " + _vm._s(_vm.locale.t("t_my_trainings")))]), _vm._v(" "), (_vm.showRestTrainings) ? _c('p', {
    class: _vm.getTrainingCountClass()
  }, [_vm._v(_vm._s(_vm.restOfTraining))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "my-trainings-div half"
  }, [_c('div', {
    staticClass: "my-trainings-debtor"
  }, [(_vm.isDebtor) ? _c('p', {
    staticClass: "my-trainings-debtor-text"
  }, [_vm._v(_vm._s(_vm.locale.t("t_debtor")))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.role === 'ROLE_TRAINER') ? _c('div', {
    staticClass: "scrollmenu"
  }, [_vm._l((_vm.trainingTypes), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickTrainingTypes(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n          ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu trainings-date-strip"
  }, [(_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "date-picker-btn trainings-date-item",
    class: _vm.formatedChoosedDate === _vm.currentDate ? 'scrolmenuitem' : 'scrolmenuitemNotSelected',
    on: {
      "click": function($event) {
        return _vm.openDatePicker()
      }
    }
  }, [(_vm.choosedDate == null) ? _c('p', {
    class: _vm.formatedChoosedDate === _vm.currentDate ? 'scrolmenuitemSelectedTextUp' : 'scrolmenuitemNotSelectedTextUp'
  }, [_vm._v("\n            " + _vm._s(_vm.locale.t('label_choose')))]) : _vm._e(), _vm._v(" "), (_vm.choosedDate == null) ? _c('br') : _vm._e(), _vm._v(" "), _c('p', {
    class: _vm.formatedChoosedDate === _vm.currentDate ? 'scrolmenuitemSelectedTextDown' : 'scrolmenuitemNotSelectedTextDown'
  }, [_vm._v("\n            " + _vm._s(_vm.locale.t('label_date')))]), _vm._v(" "), (_vm.choosedDate != null) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.choosedDate != null) ? _c('p', {
    class: _vm.formatedChoosedDate === _vm.currentDate ? 'scrolmenuitemSelectedTextDown' : 'scrolmenuitemNotSelectedTextDown'
  }, [_vm._v("\n            " + _vm._s(_vm.formatedChoosedDate))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.choosedDate),
      expression: "choosedDate"
    }],
    ref: "dateInput",
    staticStyle: {
      "position": "absolute",
      "opacity": "0",
      "width": "10px",
      "height": "10px",
      "margin-left": "-20px"
    },
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.choosedDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.choosedDate = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listDates), function(date) {
    return _c('div', {
      staticClass: "trainings-date-item",
      class: date === _vm.currentDate ? 'scrolmenuitem' : 'scrolmenuitemNotSelected',
      on: {
        "click": function($event) {
          return _vm.setDate(date)
        }
      }
    }, [_c('p', {
      class: date === _vm.currentDate ? 'scrolmenuitemSelectedTextUp' : 'scrolmenuitemNotSelectedTextUp'
    }, [_vm._v("\n            " + _vm._s(_vm.formatDay(date, false)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
      class: date === _vm.currentDate ? 'scrolmenuitemSelectedTextDown' : 'scrolmenuitemNotSelectedTextDown'
    }, [_vm._v("\n            " + _vm._s(_vm.displayDate(date)))])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.enableShowOnlyFreeSlot) ? _c('div', {
    staticClass: "foo btn-my"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showOnlyFreeSlot),
      expression: "showOnlyFreeSlot"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox2",
      "name": "myTrainings"
    },
    domProps: {
      "checked": Array.isArray(_vm.showOnlyFreeSlot) ? _vm._i(_vm.showOnlyFreeSlot, null) > -1 : (_vm.showOnlyFreeSlot)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showOnlyFreeSlot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showOnlyFreeSlot = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showOnlyFreeSlot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showOnlyFreeSlot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', [_c('label', {
    attrs: {
      "for": "checkbox2"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_show_only_free_slots")))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scrollmenu"
  }, [(_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.isTrainerApprove()) ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addTraining()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_add_term")) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.viewTrainings
    }
  }, [_c('i', {
    staticClass: "ti-view-list"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_see_terms")) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.role === 'ROLE_TRAINER') ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.signUpUserToOpenGym
    }
  }, [_c('i', {
    staticClass: "ti-view-grid"
  }), _vm._v(" " + _vm._s(_vm.locale.t("label_add_sign_up_user")) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.role === 'ROLE_TRAINER') ? _c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.changeFilterView()
      }
    }
  }, [_c('i', {
    staticClass: "ti-layout"
  }), _vm._v(" " + _vm._s(_vm.locale.t(_vm.filterView === 'table' ? "label_view_slot" : "label_view_table")) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.isMobile && _vm.filterView === 'classic') ? _c('div', _vm._l((_vm.filteredSlots), function(slot) {
    return _c('div', {
      staticClass: "new-training-item",
      attrs: {
        "disabled": slot.trainingCount <= 0
      }
    }, [_c('div', {
      staticClass: "training-item-column left"
    }, [_c('div', {
      staticClass: "new-training-item-time"
    }, [_c('span', {
      staticClass: "rotate-centered"
    }, [_vm._v(_vm._s(slot.startAt))])])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column middle",
      style: (_vm.getColorForType(slot.trainingType))
    }, [_c('div', {
      staticClass: "training-item-column-inner first"
    }, [_c('div', {
      staticClass: "training-item-column-inner-single-row"
    }, [_c('p', {
      staticClass: "training-item-column-inner-single-row-title"
    }, [_c('span', {
      style: (_vm.getDynamicColor('ti_title'))
    }, [_vm._v(_vm._s(slot.trainingType))])])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner-single-row"
    }, [(slot.rsubscribers != null && slot.rsubscribers.length > 0 && _vm.isVisibleSeeWaitingList()) ? _c('p', {
      staticClass: "training-item-column-inner-single-row-middle",
      style: (_vm.getDynamicColor('ti_desc'))
    }, [_c('b', [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showWaitingList(slot)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(_vm.locale.t('label_on_waiting')) + "\n                  " + _vm._s(slot.rsubscribers.split(",").filter(function (e) { return e.length > 0; }).length))])])])]) : _vm._e(), _vm._v(" "), (slot.rsubscribers == null || slot.rsubscribers.length === 0 || !_vm.isVisibleSeeWaitingList()) ? _c('p', {
      staticClass: "training-item-column-inner-single-row-middle",
      style: (_vm.getDynamicColor('ti_desc'))
    }, [_vm._v("\n                " + _vm._s(slot.deactivated ? _vm.locale.t("t_deactive") : _vm.locale.t("t_active"))), _c('b', [_vm._v(_vm._s(slot.trainerOnSlot != null ? " - " + slot.trainerOnSlot : ""))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner-single-row"
    }, [(slot.trainingCount > 0) ? _c('div', {
      staticClass: "training-item-column-inner-single-half green slot-width-full",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showSeeTrainingsFun(slot)
        }
      }
    }, [_vm._v("\n                " + _vm._s(slot.trainingCount) + " " + _vm._s(_vm.locale.t("t_free"))), _c('a', {
      attrs: {
        "href": "#trainings"
      }
    }, [_vm._v(" " + _vm._s(_vm.locale.t("t_see_all")))])]) : _vm._e(), _vm._v(" "), (slot.trainingCount <= 0) ? _c('div', {
      staticClass: "training-item-column-inner-single-half red slot-width-full",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showSeeTrainingsFun(slot)
        }
      }
    }, [_vm._v("\n                " + _vm._s(slot.trainingCount) + " " + _vm._s(_vm.locale.t("t_free")) + " "), _c('a', {
      attrs: {
        "href": "#trainings"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.locale.t("t_see_all")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner second"
    }, [(slot.trainingCount > 0 && !_vm.userDoNotHavePermissionToReserve) ? _c('div', {
      staticClass: "training-button-reserve",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.reserveTraining(slot)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t("t_reserve")) + "\n            ")]) : _vm._e(), _vm._v(" "), (slot.trainingCount <= 0 && !_vm.isSubscriberToSlot(slot)) ? _c('div', {
      staticClass: "training-button-reserve",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.subscribeToSlot(slot)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t("t_waiting_list")) + "\n            ")]) : _vm._e(), _vm._v(" "), (slot.trainingCount <= 0 && _vm.isSubscriberToSlot(slot)) ? _c('div', {
      staticClass: "training-button-reserve",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unsubscribeToSlot(slot)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t("t_waiting_list_cancel")) + "\n            ")]) : _vm._e()])])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', [(_vm.showNoTrainings) ? _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/icons/ic_no_trainings.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "no-data-text"
  }, [_vm._v("\n            " + _vm._s(_vm.locale.t('label_no_data_trainings')) + "\n          ")])])]) : _vm._e()]), _vm._v(" "), (_vm.filterView === 'table' && !_vm.showNoTrainings) ? _c('div', {
    staticClass: "training-new-calendar-grid"
  }, [_c('div', {
    staticClass: "training-new-header-row"
  }, [_c('div', {
    staticClass: "training-new-time-column"
  }), _vm._v(" "), _vm._l((_vm.trainers), function(trainer) {
    return _c('div', {
      key: trainer.id,
      staticClass: "training-new-trainer-column"
    }, [_vm._v("\n          " + _vm._s(trainer.name) + "\n        ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "training-new-body-grid"
  }, _vm._l((_vm.hours), function(hour) {
    return _c('div', {
      key: hour,
      staticClass: "training-new-time-row"
    }, [_c('div', {
      staticClass: "training-new-time-column"
    }, [_vm._v(_vm._s(hour) + ":00")]), _vm._v(" "), _vm._l((_vm.trainers), function(trainer, index) {
      return _c('div', {
        key: trainer.id,
        staticClass: "training-new-trainer-cell"
      }, _vm._l((_vm.getSlotsForHour(trainer.slots, hour)), function(slot) {
        return _c('div', {
          key: slot.id,
          staticClass: "training-new-training-slot",
          style: (_vm.getColorForType(slot.trainingType))
        }, [_c('b', {
          staticClass: "training-new-training-slot__title",
          style: (_vm.trainers.length > 4 ? 'font-size: 12px;' : ''),
          on: {
            "click": function($event) {
              return _vm.showSeeTrainingsFun(slot)
            }
          }
        }, [_vm._v(_vm._s(slot.startAt) + "-" + _vm._s(slot.trainingType) + " [" + _vm._s(slot.maxTrainings - slot.trainingCount) + "/" + _vm._s(slot.maxTrainings) + "]")]), _vm._v(" "), (_vm.partners.length > 0) ? _c('div', {
          staticClass: "training-new-training-slot__trainer"
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (slot.trainerOnSlot),
            expression: "slot.trainerOnSlot"
          }],
          staticClass: "training-new-training-slot__trainer-select",
          attrs: {
            "disabled": _vm.isUpdatingTrainerOnSlot(slot)
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(slot, "trainerOnSlot", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, function($event) {
              return _vm.updateTrainerOnSlot(slot)
            }]
          }
        }, [_c('option', {
          domProps: {
            "value": null
          }
        }, [_vm._v(_vm._s(_vm.locale.t('label_no_trainer')))]), _vm._v(" "), _vm._l((_vm.partners), function(item) {
          return _c('option', {
            key: item.id != null ? item.id : item.name,
            domProps: {
              "value": item.name
            }
          }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")])
        })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "training-new-training-slot__actions"
        }, [_c('span', {
          staticClass: "new-button slot-btn-sm",
          on: {
            "click": function($event) {
              return _vm.openChooseUser(slot)
            }
          }
        }, [_vm._v("+")]), _vm._v(" "), _c('span', {
          staticClass: "new-button slot-btn-sm",
          on: {
            "click": function($event) {
              return _vm.editTraining(slot)
            }
          }
        }, [_c('i', {
          staticClass: "ti-pencil"
        })]), _vm._v(" "), _c('span', {
          staticClass: "new-button slot-btn-sm",
          on: {
            "click": function($event) {
              return _vm.deleteTrainingAndUsers(slot)
            }
          }
        }, [_c('i', {
          staticClass: "ti-trash"
        })])])])
      }), 0)
    })], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.isMobile && _vm.filterView === 'classic') ? _c('div', {
    staticClass: "container w-full"
  }, [_c('div', {
    staticClass: "grid-container-new"
  }, _vm._l((_vm.filteredSlots), function(slot) {
    return _c('div', {
      staticClass: "new-training-item",
      attrs: {
        "disabled": slot.trainingCount <= 0
      }
    }, [_c('div', {
      staticClass: "training-item-column left-web"
    }, [_c('div', {
      staticClass: "new-training-item-time-web"
    }, [_c('span', {
      staticClass: "new-training-item-time-web-text"
    }, [_vm._v(_vm._s(slot.startAt))])])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column middle-web",
      style: (_vm.getColorForType(slot.trainingType)),
      on: {
        "click": function($event) {
          return _vm.showSeeTrainingsFun(slot)
        }
      }
    }, [_c('div', {
      staticClass: "training-item-column-inner first"
    }, [_c('div', {
      staticClass: "training-item-column-inner-single-row"
    }, [_c('p', {
      staticClass: "training-item-column-inner-single-row-title",
      style: (_vm.getTextLengthStyle(slot.trainingType))
    }, [_c('span', {
      style: (_vm.getDynamicColor('ti_title'))
    }, [_vm._v(_vm._s(slot.trainingType))])])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner-single-row"
    }, [(slot.rsubscribers != null && slot.rsubscribers.length > 0 && _vm.isVisibleSeeWaitingList()) ? _c('p', {
      staticClass: "training-item-column-inner-single-row-middle",
      style: (_vm.getDynamicColor('ti_desc'))
    }, [_c('b', [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showWaitingList(slot)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(_vm.locale.t('label_on_waiting')) + "\n                    " + _vm._s(slot.rsubscribers.split(",").filter(function (e) { return e.length > 0; }).length))])])])]) : _vm._e(), _vm._v(" "), (slot.rsubscribers == null || slot.rsubscribers.length === 0 || !_vm.isVisibleSeeWaitingList()) ? _c('p', {
      staticClass: "training-item-column-inner-single-row-middle",
      style: (_vm.getDynamicColor('ti_desc'))
    }, [_vm._v("\n                  " + _vm._s(slot.deactivated ? _vm.locale.t("t_deactive") : _vm.locale.t("t_active")) + "\n                  "), _c('b', [_vm._v(_vm._s(slot.trainerOnSlot != null ? " - " + slot.trainerOnSlot : ""))])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner-single-row"
    }, [(slot.trainingCount > 0) ? _c('div', {
      staticClass: "training-item-column-inner-single-half green slot-width-full",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showSeeTrainingsFun(slot)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(slot.trainingCount) + "\n                  " + _vm._s(slot.trainingCount !== 1 ? _vm.locale.t("t_free") : _vm.locale.t("t_free_single"))), _c('a', {
      attrs: {
        "href": "#trainings"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("t_see_all")))])]) : _vm._e(), _vm._v(" "), (slot.trainingCount <= 0) ? _c('div', {
      staticClass: "training-item-column-inner-single-half red slot-width-full",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showSeeTrainingsFun(slot)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(slot.trainingCount) + " " + _vm._s(_vm.locale.t("t_free")) + " "), _c('a', {
      attrs: {
        "href": "#trainings"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("t_see_all")))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "training-item-column-inner second"
    }, [(slot.trainingCount > 0 && !_vm.userDoNotHavePermissionToReserve) ? _c('div', {
      staticClass: "training-button-reserve",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.reserveTraining(slot)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t("t_reserve")) + "\n              ")]) : _vm._e(), _vm._v(" "), (slot.trainingCount <= 0 && !_vm.isSubscriberToSlot(slot)) ? _c('div', {
      staticClass: "training-button-reserve",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.subscribeToSlot(slot)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t("t_waiting_list")) + "\n              ")]) : _vm._e(), _vm._v(" "), (slot.trainingCount <= 0 && _vm.isSubscriberToSlot(slot)) ? _c('div', {
      staticClass: "training-button-reserve",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unsubscribeToSlot(slot)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t("t_waiting_list_cancel")) + "\n              ")]) : _vm._e()])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.role === 'ROLE_TRAINER')) ? _c('div', {
    attrs: {
      "id": "table-for-admin"
    }
  }, [_c('div', {
    staticClass: "foo width-half"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showTotalTermins) ? _c('div', {
    staticClass: "foo"
  }, [_c('label', [_vm._v(_vm._s(_vm.locale.t("label_amount_terms")) + ": " + _vm._s(_vm.filteredSlots.length) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('label', [_vm._v(_vm._s(_vm.locale.t("label_amount_trainings")) + ": " + _vm._s(_vm.filteredTrainings.length) + " ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.myTrainings),
      expression: "myTrainings"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox",
      "name": "myTrainings"
    },
    domProps: {
      "checked": Array.isArray(_vm.myTrainings) ? _vm._i(_vm.myTrainings, null) > -1 : (_vm.myTrainings)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.myTrainings,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.myTrainings = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.myTrainings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.myTrainings = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('span', [_c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_show_my_trainings")))])]), _vm._v(" "), (_vm.slots.length > 0) ? _c('div', {
    staticClass: "flex-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slotFilter),
      expression: "slotFilter"
    }],
    attrs: {
      "name": "slot_filter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.slotFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    key: -1,
    attrs: {
      "value": "-1"
    }
  }), _vm._v(" "), (_vm.usersCanReserveTrainingWithScanQr) ? _c('option', {
    key: -2,
    attrs: {
      "value": "-2"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.locale.t('label_qr_code_training_type')) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredSlots), function(slot) {
    return _c('option', {
      key: slot.id,
      domProps: {
        "value": slot.id
      }
    }, [_vm._v("\n              " + _vm._s(slot.startAt) + "-" + _vm._s(slot.trainingType) + "\n            ")])
  })], 2), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.filteredTrainings.length > 0) ? _c('div', {
    staticClass: "new-button btn-my",
    on: {
      "click": function($event) {
        return _vm.generateExcelFile()
      }
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_download_training_data')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "trainings"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "border": "1px red"
    }
  }, [_c('thead', [_c('tr', [(_vm.useProfilePictures) ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_picture")))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_surname")))]), _vm._v(" "), (_vm.loyaltyProgramsList.length > 0) ? _c('th', {
    staticStyle: {
      "width": "200px",
      "min-width": "120px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t('label_loyalty')) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.sortByTime = _vm.sortByTime === 'ASC' ? 'DESC' : 'ASC'
      }
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_time")) + " "), _c('i', {
    class: _vm.sortByTime === 'ASC' ? 'ti-arrow-up' : 'ti-arrow-down'
  })]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_date")))]), _vm._v(" "), (_vm.showUserTrainingTypeOnTraining) ? _c('th', {
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("label_user_training_type")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("label_number_of_trainings")) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && !_vm.hiddenColumns.includes('NOT_ARRIVED')) ? _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("label_number_of_not_arrived")) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && _vm.shouldApproveReservedTraining) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("label_approved")) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && !_vm.hiddenColumns.includes('EQUIPMENTS')) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_equipment")) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && _vm.showAddKeyForTraining && !_vm.hiddenColumns.includes('EQUIPMENTS')) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("label_training_key")) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && _vm.showTrainerOnTrainingPage) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.locale.t("label_trainer")) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_cancel")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredTrainings), function(training) {
    return _c('tr', {
      style: (_vm.getTrainingStyleTr(training))
    }, [(_vm.useProfilePictures) ? _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(training.profilePicture != null && training.profilePicture.length > 0) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": training.profilePicture
      },
      on: {
        "click": function($event) {
          return _vm.openImage(training.profilePicture, training.userId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (training.profilePicture == null || training.profilePicture.length === 0) ? _c('img', {
      staticClass: "cropped1-missing user-avatar-sm",
      attrs: {
        "src": require("../../assets/img/icons/missing_image.svg")
      },
      on: {
        "click": function($event) {
          return _vm.openImage('', training.userId)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_name')
      },
      on: {
        "click": function($event) {
          return _vm.openUser(training)
        }
      }
    }, [_c('p', {
      class: _vm.getStyleByMemberShip(training)
    }, [_vm._v(_vm._s(training.firstName))])]), _vm._v(" "), _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_surname')
      },
      on: {
        "click": function($event) {
          return _vm.openUser(training)
        }
      }
    }, [_c('p', {
      class: _vm.getStyleByMemberShip(training)
    }, [_vm._v(_vm._s(training.lastName))])]), _vm._v(" "), (_vm.loyaltyProgramsList.length > 0) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_loyalty')
      }
    }, _vm._l((_vm.loyaltyProgramsList), function(item) {
      return _c('span', {
        staticClass: "loyalty-badge-item"
      }, [_c('p', {
        style: (_vm.loyaltyStyle(item, training.paidMonthsInRow))
      }, [_vm._v(_vm._s(training.paidMonthsInRow > item ? item : training.paidMonthsInRow) + "/" + _vm._s(item))])])
    }), 0) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_time')
      },
      on: {
        "click": function($event) {
          _vm.sortByTime = _vm.sortByTime === 'ASC' ? 'DESC' : 'ASC'
        }
      }
    }, [_vm._v(_vm._s(training.startAt) + " "), _c('i', {
      class: _vm.sortByTime === 'ASC' ? 'ti-arrow-up' : 'ti-arrow-down'
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_date')
      }
    }, [_vm._v(_vm._s(training.date))]), _vm._v(" "), (_vm.showUserTrainingTypeOnTraining) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_user_training_type')
      }
    }, [_vm._v("\n                  " + _vm._s(training.userTrainingType != null ? training.userTrainingType : '/') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_number_of_trainings')
      }
    }, [_vm._v("\n                  " + _vm._s(training.restOfTrainings) + "\n                ")]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && !_vm.hiddenColumns.includes('NOT_ARRIVED')) ? _c('td', {
      style: (_vm.getNotArrivalStyle(training.notArrival)),
      attrs: {
        "data-title": _vm.locale.t('label_number_of_not_arrived')
      }
    }, [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.removeNotArrival(training.userId)
        }
      }
    }, [_c('i', {
      staticClass: "ti-minus"
    })]), _vm._v("\n                  " + _vm._s(training.notArrival) + "\n                  "), _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.addNotArrival(training.userId)
        }
      }
    }, [_c('i', {
      staticClass: "ti-plus"
    })])]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && _vm.shouldApproveReservedTraining) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_approved')
      }
    }, [(training.checkedByQr === true) ? _c('img', {
      staticClass: "icon-sm",
      attrs: {
        "src": require("../../assets/img/icons/ic_checked.svg")
      }
    }) : _vm._e(), _vm._v(" "), (training.checkedByQr == null || training.checkedByQr === false) ? _c('img', {
      staticClass: "icon-sm-clickable",
      attrs: {
        "src": require("../../assets/img/icons/ic_unchecked.svg")
      },
      on: {
        "click": function($event) {
          return _vm.approveTraining(training, true)
        }
      }
    }) : _vm._e(), _vm._v(" "), (training.checkedByQr == null || training.checkedByQr === false) ? _c('div', [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.approveTraining(training, true)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_approve')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && !_vm.hiddenColumns.includes('EQUIPMENTS')) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_equipment')
      }
    }, [_c('p', [_vm._v(_vm._s(training.additionalKit))])]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && _vm.showAddKeyForTraining && !_vm.hiddenColumns.includes('KEYS')) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_training_key')
      }
    }, [(training.key.length > 0) ? _c('p', [_vm._v(_vm._s(training.key))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.addKey(training.id, training.key)
        }
      }
    }, [(training.key.length > 0) ? _c('i', {
      staticClass: "ti-pencil"
    }) : _vm._e(), (training.key.length <= 0) ? _c('i', {
      staticClass: "ti-plus"
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "ti-key"
    })])]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && _vm.showTrainerOnTrainingPage) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_trainer')
      }
    }, [_c('p', [_vm._v(_vm._s(training.paymentCompany))])]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_cancel')
      }
    }, [(_vm.username === training.username || _vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN' || _vm.role === 'ROLE_TRAINER') ? _c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.deleteTraining(training)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    }), _vm._v(" " + _vm._s(_vm.locale.t("label_cancel")) + "\n                  ")]) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('my-trainings', {
    attrs: {
      "show": _vm.showMyTrainings
    }
  }), _vm._v(" "), _c('see-trainings', {
    attrs: {
      "show": _vm.showSeeTrainings,
      "date": _vm.currentDate,
      "trainingType": _vm.showSeeTrainingsType,
      "startAt": _vm.showSeeTrainingsStartAt
    }
  }), _vm._v(" "), _c('show-image-dialog', {
    attrs: {
      "show": _vm.showImagePreview,
      "image": _vm.imageToPreview,
      "userId": _vm.imageToPreviewUserId
    }
  }), _vm._v(" "), _c('delete-waiting-list', {
    attrs: {
      "show": _vm.showWaitingListData,
      "list": _vm.listToPreview,
      "slotItem": _vm.slotToPreview
    }
  }), _vm._v(" "), _c('choose-user-modal', {
    attrs: {
      "show": _vm.chooseUser
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48066338!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trainings/Trainings.vue
// module id = 773
// module chunks = 0